






















































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import InspectionDialogComponent from '@/components/InspectionDialogComponent.vue'
import { Inspection } from '@/domain/Inspection'
import { Classification } from '@/domain/Classification'
import InspectionService from '@/service/InspectionsService'
import ClassificationsService from '@/service/ClassificationsService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    InspectionDialogComponent,
  },
})
export default class MasterInspectionList extends Mixins(GlobalMixin) {
  inspectionService = InspectionService.instance
  classificationsService = ClassificationsService.instance

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "検査項目コード", value: "code", width: "140px" },
          { text: "検査項目名", value: "name" },
          { text: "検査項目略名", value: "shortName", width: "200px" },
          { text: "検査分類名", value: "classificationCode", width: "200px" },
          { text: "その他項目", value: "otherItem", align: "center", width: "120px" },
          { text: "検査日数", value: "days", align: "end", width: "100px" },
          { text: "操作", value: "actions", sortable: false, width: "60px" },
  ]
  list: Inspection[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  classifications: Classification[] = []

  dto: Inspection =  new Inspection()
  inspectionDialog = false

  /** 検索キーワード */
  keyword = ""
  
  /**
   * 初期実行
   */
  mounted() {
    /* 検査分類 */
    this.classificationsService.findAll()
      .then(x => this.classifications = x)
    /* 初期検索 */  
    this.search()
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Inspection) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.code) {
      this.onEdit(event.code)
    }
    this.rowItemKey = event.code
    this.rowItemClickTime = now
  }

  /**
   * 検査分類名を取得する
   */
  getClassificationName(code: string) {
    const classification = this.classifications.find(x => x.code === code)
    return classification === undefined ? "" : classification.name
  }

  /**
   * 新規作成
   */
  onNew() {
    this.inspectionService.createNew()
      .then(x => {
        this.viewMode = VIEW_MODE.NEW
        this.dto = x
        this.inspectionDialog = true
      })
  }

  /**
   * 編集
   */
  onEdit(code: string) {
    this.inspectionService.edit(code)
      .then(x => {
        this.viewMode = VIEW_MODE.EDIT
        this.dto = x
        this.inspectionDialog = true
      })
  }

  /**
   * ダイアログの確定処理
   */
  onInspectionSubmit(dto: Inspection) {
    this.showLoading()
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 新規登録 */
      this.inspectionService.create(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    } else {
      /* 更新 */
      this.inspectionService.update(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    }
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.inspectionService.findAll()
      .then(x => {
        this.list = x
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
